import {
  text,
  boolean,
  number,
  object,
  select,
  array,
} from '@storybook/addon-knobs';
import { action } from '@storybook/addon-actions';
import { storiesOf } from '@storybook/react';
import * as React from 'react';
import { AssertRiskProfileComponent, IAssertRisk } from './assertRiskProfile';
import { TQuestionData } from '../models/riskQuestion.model';
import { TRiskChoice } from '../models/riskChoice.model';

let choices: TRiskChoice[] = [
  {
    choiceId: 1,
    sequence: 1,
    choice: 'Low',
    score: 0.33333298563957214,
    selected: true,
  },
  {
    choiceId: 2,
    sequence: 2,
    choice: 'Moderate',
    score: 0.6666659712791443,
    selected: false,
  },
  {
    choiceId: 3,
    sequence: 3,
    choice: 'High',
    score: 0.9999989867210388,
    selected: false,
  },
  {
    choiceId: 4,
    sequence: 4,
    choice: 'Very High',
    score: 1.3333319425582886,
    selected: false,
  },
  {
    choiceId: 5,
    sequence: 5,
    choice: 'Very High',
    score: 1.3333319425582886,
    selected: false,
  },
  {
    choiceId: 6,
    sequence: 6,
    choice: 'Very High',
    score: 1.3333319425582886,
    selected: false,
  },
];

let commonQuestionData: TQuestionData = {
  heading: 'Common Question Data Heading',
  questionId: 1,
  sequence: 1,
  question: 'Data for the question section will resides here .........',
  choices: choices,
  selectedChoiceId: 1,
};

let data: IAssertRisk = {
  /* Slide Number: 1, maximumDecline: 2, stockMarketForecast: 3, ageRange: 4, plannedWithdrawal: 5 */
  currentRiskSequence: 1,
  /** */
  investmentAmount: 500000,
  /** pass correct realistic data*/
  riskTolerance: commonQuestionData,
  /** pass correct realistic data */
  timeHorizon: commonQuestionData,
  /** pass correct realistic data */
  investmentPercentage: commonQuestionData,
  /** pass correct realistic data */
  yourRiskProfile: commonQuestionData,
};

export const actions = {
  onBackButtonClick: action('onBackButtonClick'),
  onNextButtonClick: action('onNextButtonClick'),
  onSkipButtonClick: action('onSkipButtonClick'),
};

// storiesOf('Assert Risk Profile', module).add('Default (Investment Return)', () => {
//   return (
//     <div style={{ width: '930px' }}>
//       <AssertRiskProfileComponent
//         data={object('data', {...data})}
//         backButtonText={'Back'}
//         skipButtonText={'Skip'}
//         nextButtonText={'Next'}
//         {...actions}
//       />
//     </div>
//   );
// });

// storiesOf('Assess Risk Profile', module).add('Maximum Decline', () => {
//   return (
//     <div style={{ width: '930px' }}>
//       <AssessRiskProfileComponent
//         data={object('data', {...data, currentRiskSequence:2})}
//         backButtonText={'Back'}
//         skipButtonText={'Skip'}
//         nextButtonText={'Next'}
//         {...actions}
//       />
//     </div>
//   );
// });
